import VideoControls from './VideoControls'
export default VideoControls